export default __webpack_public_path__ + "static/media/client14.d53612a4.jpg";